import { KeycloakService } from '../../services/keycloak.service';

/** Mirrors OrganisationFieldAccess on the server (C2027-194, C2027-195). SECTOR counts as admin (PO, Q1). */
export type OrganisationField =
  | 'name'
  | 'sectorOwner'
  | 'negoceOwner'
  | 'address'
  | 'addressExtra'
  | 'postcode'
  | 'city'
  | 'country'
  | 'phone'
  | 'hasI18n'
  | 'defaultLanguageGui'
  | 'defaultLanguagePdf'
  | 'hasBeApi'
  | 'urlLogo'
  | 'sendAfterExpertValidation'
  | 'notifyAdvisorsOnAvailability'
  | 'notifyManagerOnAvailability'
  | 'wanakaBroadcastsToFarmers'
  | 'wanakaMakesVisible'
  | 'forcedBroadcastDelay'
  | 'farmerCanCreateFarm'
  | 'farmerCanCreateParcel'
  | 'farmerCanEditParcel'
  | 'farmerCanCreateOrder'
  | 'farmerCanEditOrder'
  | 'farmerCanPlanDelivery'
  | 'fmsEnabled';

const ADMIN_ONLY: OrganisationField[] = [
  'name',
  'sectorOwner',
  'negoceOwner',
  'hasBeApi',
  'urlLogo',
  'sendAfterExpertValidation',
  'forcedBroadcastDelay',
  // Block 3 of the organisation form (C2027-198): same treatment as hasBeApi, PO Q9.
  'fmsEnabled',
];

// Of the admin-only fields, these two are hidden entirely from non-admins (C2027-195, §2.2);
// the others (name, owners, hasBeApi, urlLogo) stay visible as read-only.
const HIDDEN_FOR_NON_ADMIN: OrganisationField[] = ['sendAfterExpertValidation', 'forcedBroadcastDelay'];

export function isOrganisationAdmin(): boolean {
  return (
    KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN') || KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR')
  );
}

export function canEditOrganisationField(field: OrganisationField): boolean {
  return isOrganisationAdmin() || !ADMIN_ONLY.includes(field);
}

export function isOrganisationFieldHidden(field: OrganisationField): boolean {
  return !isOrganisationAdmin() && HIDDEN_FOR_NON_ADMIN.includes(field);
}
